import React from 'react'
import {
  GET_XML_PAYROC_CUSTOMER,
  ADD_XML_PAYROC_PAYMENT_METHOD,
  SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD,
  SET_XML_PAYROC_DELETE_PAYMENT_METHOD
} from 'requests'
import { useAppSetting } from '../../Utilities/hooks'
import useItransact from './useItransact'
import PaymentMethod from './PaymentMethod'
import { ConfirmDialog } from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import { Spinner } from 'components/Loaders/Loaders'

export default ({ profileId }) => {
  const [paymentMethods, setPaymentMethods] = React.useState(null)
  const [paymentMethodsLoading, setPaymentMethodsLoading] = React.useState(false)
  const [deletingId, setDeletingId] = React.useState(null)
  const iTransactLoaded = useItransact()
  const apiUsername = useAppSetting('PAYROC_API_USERNAME')

  const getPaymentMethods = id => {
    setPaymentMethodsLoading(true)
    GET_XML_PAYROC_CUSTOMER(
      id,
      customer => {
        if (customer === false) {
          setPaymentMethods([])
          setPaymentMethodsLoading(false)
        } else {
          setPaymentMethods(customer.payment_sources)
          setPaymentMethodsLoading(false)
        }
      },
      err => {
        console.error(err)
      }
    )
  }

  const openItransact = () => {
    const handler = window.iTransact.Checkout.init({
      apiUsername: apiUsername.setting.VALUE,
      name: 'Add new payment method',
      description: '',
      panelButtonText: 'Add method',
      billingAddress: true,
      ach: true,
      onToken: data => {
        setPaymentMethodsLoading(true)
        ADD_XML_PAYROC_PAYMENT_METHOD(
          {
            profileId,
            token: data.token
          },
          success => {
            if (success) {
              getPaymentMethods(profileId)
            }
          }
        )
      }
    })
    handler.render({
      amount: 0
    })
  }

  const setAsDefaultPaymentMethod = paySourceNum => {
    let cachedMethods = null
    setPaymentMethods(methods => {
      cachedMethods = [...methods.map(x => ({ ...x }))]
      const newDefaultIndex = methods.findIndex(x => x.id === paySourceNum)
      const noDefaults = methods.map(x => ({ ...x, default: false }))
      return [
        ...noDefaults.slice(0, newDefaultIndex),
        { ...noDefaults[newDefaultIndex], default: true },
        ...noDefaults.slice(newDefaultIndex + 1)
      ]
    })
    SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD(
      { profileId, paySourceNum },
      response => {},
      err => {
        setPaymentMethods(cachedMethods)
      }
    )
  }

  const startPaymentDelete = paySourceNum => {
    setDeletingId(paySourceNum)
  }

  const deletePaymentMethod = paySourceNum => {
    let cachedMethods = null
    setPaymentMethods(methods => {
      cachedMethods = [...methods.map(x => ({ ...x }))]
      const toDeleteIndex = methods.findIndex(x => x.id === paySourceNum)
      return [...methods.slice(0, toDeleteIndex), ...methods.slice(toDeleteIndex + 1)]
    })
    SET_XML_PAYROC_DELETE_PAYMENT_METHOD(
      { profileId, paySourceNum },
      response => {},
      err => {
        setPaymentMethods(cachedMethods)
      }
    )
  }

  React.useEffect(
    () => {
      if (profileId !== null) {
        getPaymentMethods(profileId)
      }
    },
    [profileId]
  )

  return (
    <div
      className="saved-payments-editor"
      style={{
        opacity: paymentMethodsLoading ? 0.5 : 1,
        pointerEvents: paymentMethodsLoading ? 'none' : ''
      }}
    >
      {iTransactLoaded &&
        !apiUsername.loading &&
        apiUsername.setting && (
            paymentMethods !== null ?
            <React.Fragment>
              {paymentMethods.map(method => (
                <PaymentMethod
                  type={method.type}
                  brand={method.brand}
                  last4Digits={method.last_four_digits}
                  isDefault={method.default}
                  onRequestDefault={() => setAsDefaultPaymentMethod(method.id)}
                  onRequestDelete={() => startPaymentDelete(method.id)}
                  key={method.id}
                  savingsAccount={method.savings_account}
                />
              ))}
              <div className="center">
                <button
                  className="btn btn-primary btn-raised add-button"
                  disabled={paymentMethodsLoading}
                  onClick={openItransact}
                >
                  <div className="center">
                    <PlusIcon /> Add New Payment Method
                  </div>
                </button>
              </div>
            </React.Fragment>
            :
            <div className='center' style={{marginTop: 100}}>
              <Spinner themeColor='medium-neutral' />
            </div>
          )}
      <Portal isOpened={!!deletingId}>
        <ConfirmDialog
          closeModal={() => setDeletingId(null)}
          onModalClosed={() => {}}
          message="Are you sure you want to delete this payment method? This cannot be undone."
          buttons={[
            { label: 'No', onClick: () => {}, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: () => deletePaymentMethod(deletingId),
              className: 'btn-danger'
            }
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      </Portal>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/SavedPayments/SavedPaymentsDrawer.js